function textOpen() {
	const btnOpen = document.querySelectorAll('.item__label')

	btnOpen.forEach(openBtn => {
		openBtn.addEventListener('click', e => {
			const textGreen = openBtn.querySelector('.item__title-info--btn')
			const textOpening = openBtn.querySelector('.item__title-info--open')
			const imgI = openBtn.parentElement.querySelector('.news-slider') // Используем parentElement для доступа к родителю
			const imgS = openBtn.parentElement.querySelector('.swiper-wrapper') // Используем parentElement для доступа к родителю

			if (
				textOpening.style.display === 'none' ||
				textOpening.style.display === ''
			) {
				textOpening.style.display = 'inline'
				textGreen.style.display = 'none'
				if (imgI) imgI.style.display = 'block' // Проверяем наличие imgI
				if (imgS) imgS.style.display = 'flex' // Проверяем наличие imgS
			} else {
				textOpening.style.display = 'none'
				textGreen.style.display = 'inline'
				if (imgI) imgI.style.display = 'none'
				if (imgS) imgS.style.display = 'none'
			}
		})
	})
}
